import logo from './logos/logo_admin.svg';
import symbol_logo from './logos/pa_symbol.png';
import heuron_logo from './logos/pa_heuron_logo.svg';
import heuron_logo_desc from './logos/pa_heuron_logo_with_desc.svg';
export const logos = {
  logo,
  symbol_logo,
  heuron_logo,
  heuron_logo_desc,
};
